'use strict';

/**
 * Moodboard-DrawingSource
 * -----------------------
 * Backs the moodboard Drawing card's picker (options.DrawingSource). It surfaces two things a person
 * would expect under "pull a drawing": the team's Excalidraw **Drawings** (Media owned by
 * OwnerType 'Drawing', IDOwner 0 -- see PictView-DrawingsPage: each is a self-contained SVG blob with
 * its scene embedded), plus this board's own gallery Media (OwnerType 'Moodboard', IDOwner = the open
 * board). Drawings come first because that is the thing the card is named for.
 *
 * It extends Moodboard-MediaImageSource so the field descriptors, query (search / filter / sort),
 * upload (an uploaded file lands in the board gallery), and _toItem all come for free; only list() and
 * getItem() are widened to also read the Drawings collection. Both collections are Media rows keyed by
 * IDMedia, so a drawing card links to one by id and "Update from source" re-pulls it -- and because a
 * re-saved Excalidraw drawing replaces the same IDMedia's bytes, the card refreshes to the new version.
 */

const libMoodboardMediaImageSource = require('./Moodboard-MediaImageSource.js');

const _DRAWINGS_OWNER_TYPE = 'Drawing';
const _DRAWINGS_OWNER_ID = 0;

class MoodboardDrawingSource extends libMoodboardMediaImageSource
{
	// Fetch the team drawings + this board's gallery, mapped to items and deduped by IDMedia (drawings first).
	_collect()
	{
		if (!this._MediaAPI) { return Promise.resolve([]); }
		let tmpOwnerId = this._getOwnerId();
		let tmpDrawings = this._MediaAPI.listForOwner(_DRAWINGS_OWNER_TYPE, _DRAWINGS_OWNER_ID).catch(() => []);
		let tmpBoard = this._hasOwner(tmpOwnerId) ? this._MediaAPI.listForOwner(this._OwnerType, tmpOwnerId).catch(() => []) : Promise.resolve([]);
		return Promise.all([tmpDrawings, tmpBoard]).then((pResults) =>
		{
			let tmpRows = (Array.isArray(pResults[0]) ? pResults[0] : []).concat(Array.isArray(pResults[1]) ? pResults[1] : []);
			let tmpSeen = {};
			let tmpItems = [];
			tmpRows.forEach((pRow) =>
			{
				if (pRow && (pRow.IDMedia != null) && !tmpSeen[pRow.IDMedia])
				{
					tmpSeen[pRow.IDMedia] = true;
					tmpItems.push(this._toItem(pRow));
				}
			});
			return tmpItems;
		});
	}

	list(pQuery)
	{
		return this._collect().then((pItems) => this._applyQuery(pItems, pQuery || {})).catch(() => []);
	}

	getItem(pId)
	{
		if (pId == null) { return Promise.resolve(null); }
		return this._collect()
			.then((pItems) => pItems.find((pItem) => String(pItem.Id) === String(pId)) || null)
			.catch(() => null);
	}
}

module.exports = MoodboardDrawingSource;
